<template>
  <div>
    <el-dialog :title="title" :visible.sync="dialogVisible" width="40%" center>
      <div style="display:flex; justify-content: center;">
        <el-form :model="n2n" ref="n2n" :rules="rules" label-position="right" label-width="120px">
          <el-form-item :label="`${$t('lang.n2n.serverName')}：`" prop="serverName">
            <el-input size="mini" class="admininput" v-model="n2n.serverName" :placeholder="$t('lang.n2n.inputEmpty')"
              clearable></el-input>
          </el-form-item>
          <el-form-item :label="`${$t('lang.n2n.version')}：`" prop="serverVersion">
            <!-- <el-input size="mini" class="admininput" v-model="n2n.serverVersion" :placeholder="$t('lang.n2n.inputEmpty')" clearable></el-input> -->
            <el-select size="mini" class="admininput" v-model="n2n.serverVersion"
              :placeholder="$t('lang.n2n.inputEmpty')" clearable>
              <el-option v-for="item in n2nVersion" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="`${$t('lang.n2n.serverAddress')}：`" prop="serverHost">
            <el-input size="mini" class="admininput" v-model="n2n.serverHost" :placeholder="$t('lang.n2n.inputEmpty')"
              clearable></el-input>
          </el-form-item>
          <el-form-item :label="`${$t('lang.n2n.port')}：`" prop="serverPort">
            <el-input size="mini" class="admininput" v-model="n2n.serverPort" :placeholder="$t('lang.n2n.inputEmpty')"
              clearable></el-input>
          </el-form-item>
          <el-form-item :label="`${$t('lang.n2n.groupAutomaticDistribution')}：`">
            <el-checkbox v-model="n2n.serverSwitch"></el-checkbox>
            <p class="tips">
              {{ $t('lang.n2n.groupTips') }}
            </p>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="CancelWatchN2N">{{ $t('lang.Button.cancel') }}</el-button>
        <el-button size="mini" type="primary" @click="SubmitFrom">{{ $t('lang.Button.submit') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    title: String,
    Identification: Number, //1为添加,2为修改n2n信息,3为修改n2n分组端口号
    n2n: Object
  },
  data() {
    var checkPort = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('lang.n2n.versionEmpty')))
      } else if (!/^[0-9]+$/.test(value)) {
        callback(new Error(this.$t('lang.n2n.versionInt')))
      } else if (value < 9001 || value > 50000) {
        callback(new Error(this.$t('lang.n2n.portRang')))
      } else {
        callback()
      }
    }
    return {
      //n2n弹出框表单数据
      dialogVisible: false,
      WatchN2N: {},
      rules: {
        serverName: [
          { required: true, trigger: 'blur', message: this.$t('lang.n2n.serverEmpty') }
        ],
        serverVersion: [
          { required: true, trigger: 'blur', message: this.$t('lang.n2n.versionEmpty') }
        ],
        serverPort: [
          { required: true, validator: checkPort, trigger: 'blur', }
        ],
        serverHost: [
          { required: true, trigger: 'blur', message: this.$t('lang.n2n.serverAddressEmpty') }
        ]
      },
      n2nVersion: [
        {
          label: '2',
          value: '2'
        },
        {
          label: '3',
          value: '3'
        },
        {
          label: '4',
          value: '4'
        }
      ]
    };
  },
  computed: {
    //使用计算属性避免对象变异获取不到改变前的值
    getnewValue() {
      return JSON.parse(JSON.stringify(this.n2n));
    }
  },
  watch: {
    getnewValue: {
      handler(newValue, oldValue) {
        if (Object.keys(this.WatchN2N).length == 0) {
          this.WatchN2N = newValue
        }
      }
    }
  },
  methods: {
    //WatchN2N
    CancelWatchN2N() {
      this.WatchN2N = {}
      this.dialogVisible = false
    },
    //传递表单数据给父组件
    SubmitFrom() {
      this.$refs.n2n.validate(valid => {
        if (valid) {
          //修改n2n服务时弹出警告框
          if (this.Identification == 2) {
            //改变n2n名称版本号与端口号分开请求
            let data = {}
            for (let key in this.n2n) {
              if (this.WatchN2N[key] != this.n2n[key]) {
                data[key] = this.n2n[key]
              }
            }
            data.serverSwitch = data.serverSwitch ? 1 : 0
            //如果修改了端口号弹出警告框
            if (data.serverPort || data.serverHost) {
              this.$confirm(this.$t('lang.n2n.groupComfirm'), this.$t('lang.Button.tips'), {
                confirmButtonText: this.$t('lang.Button.confirm'),
                cancelButtonText: this.$t('lang.Button.cancel'),
                type: 'warning',
                center: true
              }).then(() => {
                data['serverPort'] = this.n2n.serverPort;
                data['serverHost'] = this.n2n.serverHost;
                this.$emit("AddAndSetN2nServer", { ...data, serverId: this.n2n.serverId }, this.Identification);
                //清空
                this.WatchN2N = {}
              })
                .catch(() => {
                  this.WatchN2N = {}
                });
            }
            //如果啥也没改直接隐藏弹出框
            else if (Object.keys(data).length == 0) {
              this.dialogVisible = false;
              //清空
              this.WatchN2N = {}
            }
            //修改了版本号与n2n名称
            else {
              this.$emit("AddAndSetN2nServer", { ...data, serverId: this.n2n.serverId }, this.Identification)
              //清空
              this.WatchN2N = {}
            }
          } else {
            this.n2n.serverSwitch ? this.n2n.serverSwitch = 1 : this.n2n.serverSwitch = 0
            this.$emit("AddAndSetN2nServer", this.n2n, this.Identification)
          }
          this.dialogVisible = false;
        } else {
          return false
        }
      })

    }
  }
};
</script>
<style scoped>
.elinput {
  margin: 0.2rem 0.2rem 0.2rem 0rem;
}

.tetxp {
  display: inline-block;
  width: 2rem;
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  text-align: right;
}

.admininput {
  display: inline-block;
  width: 4rem;
  /* margin: 0.2rem; */
}

.tips {
  color: gray;
  line-height: 16px;
}
</style>
